import { requirePermission } from '@/utils/auth'
import { createFileRoute } from '@tanstack/react-router'
import HardwareConfigurationPage from '@/components/Hardware/HardwareConfigurationPage'

export const Route = createFileRoute('/hardware/$source/$tab')({
  beforeLoad: () => requirePermission('vehicle_administration', 'write'),
  component: HardwareConfigurationPage,
})
